import React from 'react';
import LegalPage from './LegalPage';
import { CONTACT_MD } from './legalContent';

const Contact = () => (
  <LegalPage markdown={CONTACT_MD} showContactLink={false} />
);

export default Contact;
